/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled, { css } from 'styled-components';
import Colors from 'constants/Colors';
import { FontWeight } from 'components/Text';



export const ButtonContent = styled.div`
    display:flex;
    flex-direction:row;
    justify-content: space-evenly;
    background-color:#FFF;  
`;
/* export const ButtonContent = styled.div`
  display:flex;
  flex-direction:auto;
  background-color:#FFF;  
`; */

export const Scrollbox = styled.div` 
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 500px;
  padding:10px 20px 10px 10px;
  
  ::-webkit-scrollbar{
    background:${Colors.WHITE};
    width:8px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${Colors.GRAY[3]};
    border-radius: 15px;
  }
  `;

export const Text = styled.text`
  color: ${Colors.GRAY[6]};
  font-weight: ${FontWeight.SemiBold};
  text-transform: uppercase;
  font-size: 16px;
  cursor: pointer;
`;

export const TableHeader = styled.div`
  display:flex;
  flex-direction:row;
  width: 100%;
  height:24px;
  background-color: red;
`;

export const TextArea = styled.textarea`
width:100%;
height: 120px;
padding:15px;
border:2px solid ${Colors.GRAY[3]};
border-radius:8px;
resize:none;
font-family: 'FiraSans', sans-serif !important;
font-weight: ${FontWeight.SemiBold};
color: ${Colors.GRAY[6]};
font-size:14px;
`;

export const Footer = styled.div`
display: flex;
justify-content: space-between;
margin-top: 20px;  
`;

///////////////Dialog\\\\\\\\\\\\\\

export const DialogSelect = styled.div`
  width: 100%;  
  margin: 30px 0px 10px 0px;
`;

export const DialogConfirm = styled.button`
  width: calc(50% - 10px);
  margin-left: 10px;
  height: 40px;
  background: ${Colors.BLUE};
  border: 0px;
  border-radius: 5px;
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer; 
`;


export const DialogCancel = styled.button`
  width: calc(50% - 10px);
  margin-right: 10px;
  height: 40px;
  background: ${Colors.GRAY[0]};
  border: 0px;
  border-radius: 5px;
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer;     
`;

export const DialogRejected = styled.button`
  width: calc(50% - 10px);
  margin-right: 10px;
  height: 40px;
  background: ${Colors.GRAY[6]};
  border: 0px;
  border-radius: 5px;
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer;     
`;

export const CustomField = styled.div`
  div{
    min-height: auto;
    margin-bottom: 0px;
    width: 100%; 
  }
  .is-approved{
    span{
      color: ${Colors.PURPLE};
    }
  }
  .is-disabled{
    span{
      color: ${Colors.GRAY[1]}
    }
  }
`;


export const ContentAlert = styled.div`
  width: 100%;  
  margin-top: 20px;
  p{
    color: ${Colors.GRAY[1]};
    margin-bottom: 30px;
    margin-top: 0px;
    font-weight: 500;
    font-size: 14px;
  }
`;


export const Textarea = styled.textarea`
    width: 100%;
    height: 100px;
    border: 1px solid #888;
    border-radius: 4px;
    margin-top: 0px;
    padding: 14px;
    margin-bottom: 10px;
    resize:none;
`;

export const ContentTextarea = styled.div`
  width: 100%;  
  margin-top: 0px;
  margin-bottom: 0px;
  p{
    color: ${Colors.GRAY[0]};
    margin-bottom: 5px;
    margin-top: 10px;
    font-weight: 800;
    font-size: 14px;
  }
`;